<template>
  <dropdown
    :id="id"
    :label="label"
    :button-class="extraButtonClass + ' btn btn-link'"
    container-class="dropdown-light link-selector"
  >
    <li v-for="link in links" :key="link.link">
      <a :href="baseUrl + link.link">
        {{ link.name }}
      </a>
    </li>
  </dropdown>
</template>

<script>
import { Dropdown } from 'vue-bootstrap';

/**
 * The LinkSelector component.
 *
 * Expects an array of links:
 *
 * [
 *   { link: 'http://af.dev/2018', name: '2018' },
 *   { link: 'http://af.dev/2019', name: '2019' }
 * ]
 *
 */
export default {
  components: {
    Dropdown
  },
  props: {
    id: {
      type: String,
      default: 'link-selector'
    },
    links: {
      type: Array,
      required: true
    },
    activeLink: {
      type: String,
      default: ''
    },
    baseUrl: {
      type: String,
      default: ''
    },
    extraButtonClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    label() {
      if (!this.links.length) {
        return;
      }

      const firstLink = this.links.slice(0, 1)[0];
      const activeLink = this.activeLink ? this.activeLink : firstLink.link;

      return (
        this.links.find(link => link.link.toString() === activeLink) || {}
      ).name;
    }
  }
};
</script>
